module.exports = __webpack_public_path__ + "static/media/caret_up.c053d6a1.svg";